import { SVGProps } from 'react'

const SvgSingleSensorFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg fill='none' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M12 2a1 1 0 0 0-1 1v1H8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3v5a1 1 0 1 0 2 0v-5h3a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-3V3a1 1 0 0 0-1-1zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6z' />
  </svg>
)

export default SvgSingleSensorFilled
